import { render } from "./TopMenuItems.vue?vue&type=template&id=db78d84c"
import script from "./TopMenuItems.vue?vue&type=script&lang=js"
export * from "./TopMenuItems.vue?vue&type=script&lang=js"
script.render = render

export default script